import CarbonElementType from "@/model/CarbonElementType"
import ConfigurationForCarbonType from "@/model/ConfigurationForCarbonType"
import CarbonRepo from "@/repositories/carbon/CarbonRepo"
import FuelCarbonData from "@/model/FuelCarbonData"
import Ship from "@/model/Ship"
import { propulsionTypeCodes } from "../utils/constants"
import Configuration from "@/model/Configuration"

class CarbonService {
    private static instance: CarbonService
    private repo: CarbonRepo

    private constructor() {
        this.repo = new CarbonRepo(this)
    }

    public static getInstance(): CarbonService {
        if (!this.instance) {
            this.instance = new CarbonService()
        }
        return this.instance
    }

    public getCarbonData(ship) {
        console.log("CarbonService.getCarbonData", ship)
        this.repo.getCarbonData(ship)
    }

    public actualizeCarbonElementForShip(ship: Ship) {
        if (!ship.carbonData) {
            console.log("Creando nuevo carbon")
            ship.carbonData = new CarbonElementType()
        }

        this.actualizeNewConfigurationsForCarbon(ship)

        this.removeOldConfigurationsForCarbon(ship)

        return ship.carbonData
    }

    private removeOldConfigurationsForCarbon(ship: Ship) {
        let index = ship.carbonData.configurationsForCarbon.length - 1
        while (index >= 0) {
            if (
                !this.existsConfigurationWithName(
                    ship.carbonData.configurationsForCarbon[index].configurationName,
                    ship
                )
            ) {
                ship.carbonData.configurationsForCarbon.splice(index, 1)
            } else {
                this.removeOldFuelsForConfiguration(ship.carbonData.configurationsForCarbon[index], ship)
            }
            index = index - 1
        }
    }

    private removeOldFuelsForConfiguration(configurationForCarbon: ConfigurationForCarbonType, ship: Ship) {
        console.log("Vamos a ver si tenemos que borrar algún combustible de las configuraciones que sí existen")
        ship.configurations.forEach((conf) => {
            console.log("Para la configuración", conf.name)
            if (conf.name === configurationForCarbon.configurationName) {
                let index = configurationForCarbon.fuelInfo.length - 1
                while (index >= 0) {
                    if (!this.existsFuelTypeWithName(configurationForCarbon.fuelInfo[index].fuelName, conf)) {
                        configurationForCarbon.fuelInfo.splice(index, 1)
                    }
                    index = index - 1
                }
            }
        })
    }

    private existsFuelTypeWithName(fuelName: string, configuration: Configuration) {
        let result = false

        console.log("vamos a ver si existe el tipo", fuelName)

        configuration.MainEngineEmissions.forEach((mainEngine) => {
            const fuelInfoNewName = mainEngine.fuelType + " (" + configuration.name + ")"
            result = result || fuelInfoNewName === fuelName

            if (!result && mainEngine.propulsionType === propulsionTypeCodes.Dual) {
                const fuelInfoNewName2 = mainEngine.secondFuelType + " (" + configuration.name + ")"
                result = result || fuelInfoNewName2 === fuelName
            }
        })

        if (!result) {
            configuration.AuxiliaryEngineEmissions.forEach((auxEngine) => {
                const fuelInfoNewName3 = auxEngine.fuelType + " (" + configuration.name + ")"
                result = result || fuelInfoNewName3 === fuelName

                if (!result && auxEngine.propulsionType === propulsionTypeCodes.Dual) {
                    const fuelInfoNewName4 = auxEngine.secondFuelType + " (" + configuration.name + ")"
                    result = result || fuelInfoNewName4 === fuelName
                }
            })
        }

        console.log("El resultado es", result)
        return result
    }

    private existsConfigurationWithName(configurationName: string, ship: Ship) {
        let result = false
        ship.configurations.forEach((conf) => {
            result = result || conf.name === configurationName
        })
        return result
    }

    private actualizeNewConfigurationsForCarbon(ship: Ship) {
        ship.configurations.forEach((configuration) => {
            // Se comprueba si esta configuración ya se tiene en el carbon o se crea una
            let newConfigurationForCarbon = false
            let configurationForCarbon: ConfigurationForCarbonType = this.getConfigurationForCarbon(ship, configuration)
            if (!configurationForCarbon) {
                console.log("Como no la hemos encontrado, la creamos nueva")
                configurationForCarbon = new ConfigurationForCarbonType()
                configurationForCarbon.configurationName = configuration.name
                configurationForCarbon.modified_dwt = configuration.modified_dwt ? configuration.modified_dwt : 0
                configurationForCarbon.modified_gt = configuration.modified_gt ? configuration.modified_gt : 0
                newConfigurationForCarbon = true
            }

            configuration.MainEngineEmissions.forEach((mainEngine) => {
                this.getNewFuelCarbonData(mainEngine.fuelType, configuration, configurationForCarbon)

                if (mainEngine.propulsionType === propulsionTypeCodes.Dual) {
                    this.getNewFuelCarbonData(mainEngine.secondFuelType, configuration, configurationForCarbon)
                }
            })

            configuration.AuxiliaryEngineEmissions.forEach((auxEngine) => {
                this.getNewFuelCarbonData(auxEngine.fuelType, configuration, configurationForCarbon)

                if (auxEngine.propulsionType === propulsionTypeCodes.Dual) {
                    this.getNewFuelCarbonData(auxEngine.secondFuelType, configuration, configurationForCarbon)
                }
            })

            if (newConfigurationForCarbon) {
                ship.carbonData.configurationsForCarbon.push(configurationForCarbon)
            }
        })
    }

    private getConfigurationForCarbon(ship: Ship, configuration: Configuration): any {
        console.log("vamos a ver si para el carbón tenemos la configuración", configuration.name)
        let result: any = null
        ship.carbonData.configurationsForCarbon.forEach((confForCarbon) => {
            console.log("tenemos esta", confForCarbon.configurationName)
            if (confForCarbon.configurationName === configuration.name) {
                console.log("encontrada!!")
                result = confForCarbon
            }
        })
        return result
    }

    private getNewFuelCarbonData(
        fuelType: string,
        configuration: Configuration,
        configurationForCarbon: ConfigurationForCarbonType
    ) {
        const fuelInfoNewName = fuelType + " (" + configuration.name + ")"
        console.log("Vamos a ver si tenemos el tipo de combustible", fuelInfoNewName)
        let existsAlready = false
        configurationForCarbon.fuelInfo.forEach((fuelInfo) => {
            console.log("Tenemos este", fuelInfo.fuelName)
            if (fuelInfo.fuelName === fuelInfoNewName) {
                console.log("encontrado!!")
                existsAlready = true
            }
        })

        if (!existsAlready) {
            console.log("Como no lo hemos encontrado, lo creamos nuevo")
            const fuelCarbonData = new FuelCarbonData()
            fuelCarbonData.fuelName = fuelInfoNewName
            fuelCarbonData.fuelCode = fuelType
            configurationForCarbon.fuelInfo.push(fuelCarbonData)
        }
    }

    public addedCarbonData(ship: Ship, id_from_firestore: string, data: any) {
        console.log("CarbonService.addedCarbonData", ship.name, id_from_firestore, data)
        const carbonData: CarbonElementType = {
            id: "PEPEP",
            ...data
        }
        ship.carbonData = carbonData
        console.log("CarbonService.addedCarbonData carbonData=", carbonData)
        carbonData.id = id_from_firestore
        console.log("CarbonService.addedCarbonData carbonData=", carbonData)
        console.log("CarbonService.addedCarbonData Ship=", ship)
    }

    public modifiedCarbonData(ship: Ship, id: string, data: any) {
        console.log("CarbonService.modifiedCarbonData", ship.name, id, data)
        const carbonData = {
            id: id,
            ...data
        }
        ship.carbonData = carbonData
    }

    public saveCarbonData(ship: Ship, carbonData: CarbonElementType) {
        console.log("CarbonService.saveCarbonData", ship, carbonData)

        Object.keys(ship.carbonData.configurationsForCarbon).forEach((element) => {
            Object.keys(ship.carbonData.configurationsForCarbon[element].fuelInfo).forEach((element2) => {
                if (
                    ship.carbonData.configurationsForCarbon[element].fuelInfo[element2].consumptionInTonsName == "MWh"
                ) {
                    ship.carbonData.configurationsForCarbon[element].fuelInfo[element2].consumptionInTons = false
                } else {
                    ship.carbonData.configurationsForCarbon[element].fuelInfo[element2].consumptionInTons = true
                }
            })
        })

        return this.repo.saveCarbonData(ship, carbonData)
    }
}

export default CarbonService
